module.exports = __webpack_public_path__ + "img/m-flower.2cb1ba71.png";